// URL-related constants
export const SORARE_URLS = {
  BASE: 'https://sorare.com',
  FOOTBALL_CARDS: 'https://sorare.com/football/cards/',
  FOOTBALL_PLAYERS: 'https://sorare.com/football/players/',
  NBA_CARDS: 'https://sorare.com/nba/cards/',
  NBA_PLAYERS: 'https://sorare.com/nba/players/',
  MLB_CARDS: 'https://sorare.com/mlb/cards/',
};

// Default URL for unknown game types
export const DEFAULT_CARD_URL = SORARE_URLS.FOOTBALL_CARDS;
